<template>
  <section id="brands" class="brands">
    <div class="container">
      <div class="wrapper">
        <h2 class="brands__title"><span class="underlined-text underlined-text--light-gold">Brand</span> Partners</h2>
      </div>
    </div>
    <ul class="brands-list mobile-wrapper">
      <li class="brands-list-item" v-for="(brand, index) in brands" :key="index">
        <router-link class="brands-list-item-link" :to="{ name: 'brand', params: { brandSlug: brand.slug, passedBrands: brands, passedSocialLinks: socialLinks, passedShops: shops, passedContactDetails: contactDetails }}">
          <img :src="brand.productImageUrl">
                </router-link>
          <div class="brands-list-item__overlay">
            <img :src="brand.logoUrl">
                </div>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
    props: ['brands', 'socialLinks', 'shops', 'contactDetails']
}
</script>

<style lang="scss">
@import "@/assets/css/helpers-variables.scss";

.brands {
  margin-bottom: 80px;
  .wrapper {
    margin: 0 auto;
  }
  .mobile-wrapper {
    @media (max-width: 767px) {
      max-width: $phone-l;
      margin: 0 auto;
    }
  }
  @media (min-width: $laptop-s) {
    margin-bottom: 120px;
  }
}
.brands__title {
  font-size: 1.25em;
  font-weight: 600;
  line-height: 2.4;
  margin-bottom: 40px;
  text-align: center;
  @media (min-width: $laptop-s) {
    font-size: 2em;
  }
  @media (min-width: $laptop-l) {
    font-size: 2.2em;
  }
}
.brands-list {
  @media (min-width: $tablet) {
    display: flex;
  }
}
.brands-list-item {
  width: 100%;
}
.brands-list-item {
  position: relative;
}
.brands-list-item-link {
  display: block;
  width: 100%;
  > img {
    display: block;
    width: 100%;
  }
}
.brands-list-item__overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(white, 0.9);
  pointer-events: none;
  transition: all 0.2s ease;
  opacity: 0;
  img {
    display: block;
    width: 80%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .brands-list-item:hover & {
    opacity: 1;
  }
}
</style>
